<template>
  <div class="w-full flex flex-col max-w-768 mx-auto md:mt-20 py-24 md:py-48 px-16">
    <div>
      <p class="uppercase font-bold text-overline">Welcome to Sittercity</p>
      <h1 class="text-h1 mb-16">Let's continue your Back-Up Care request</h1>
    </div>
    <p class="mb-12">Which of these apply to you?</p>
    <div class="image-clickable-cards">
      <ImageLinkCard
        title="I already have a caregiver"
        content="Invite your existing caregiver to join Sittercity"
        class="mb-18 p-16"
        :clickable="true"
        @click="handleExistingCaregiverClick"
      >
        <template #rightSide>
          <DisclosureIcon class="w-full" />
        </template>
        <template #leftSide>
          <SitterTeamIcon :width="48" :height="48" />
        </template>
      </ImageLinkCard>
      <ImageLinkCard
        title="I need a new caregiver"
        content="Find a new caregiver through Sittercity"
        class="mb-18 p-16"
        :clickable="true"
        @click="handleNewCaregiverClick"
      >
        <template #rightSide>
          <DisclosureIcon class="w-full" />
        </template>
        <template #leftSide>
          <FindCareIcon :width="48" :height="48" />
        </template>
      </ImageLinkCard>
    </div>
  </div>
</template>

<script lang="ts">
import ImageLinkCard from '@/components/image_link_card/ImageLinkCard.vue';
import DisclosureIcon from '@/graphics/icons/DisclosureIcon.vue';
import SitterTeamIcon from '@/graphics/illustrations/SitterTeamIllustration.vue';
import FindCareIcon from '@/graphics/illustrations/FindCareIllustration.vue';
import { CareType } from '@/types/care_type';
import { navigateToReturnPath } from '@/helpers/routerNavigation';
import { redirectToJobPost } from '@/helpers/jobPostRedirect';

export default {
  name: 'BackupCareRequestSelection',
  components: {
    ImageLinkCard,
    DisclosureIcon,
    SitterTeamIcon,
    FindCareIcon,
  },
  props: {
    scCareSessions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mostRecentlyCreatedActiveCareSession(): any {
      const currentDateISO = new Date().toISOString();
      // These are sorted by start date by default, not by creation date
      const activeSessions = this.scCareSessions.filter((session: any) => session.start >= currentDateISO);
      if (activeSessions.length === 0) {
        return null;
      }
      return activeSessions.sort((a: any, b: any) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      })[0];
    },
    careType(): CareType | null {
      return this.mostRecentlyCreatedActiveCareSession?.careType || null;
    },
    reservationId(): string | null {
      return this.mostRecentlyCreatedActiveCareSession?.bhReservationRequest?.bhReservationRequestId || null;
    },
  },
  methods: {
    handleExistingCaregiverClick() {
      navigateToReturnPath(this.$router, '/account/seekers/dashboard');
    },
    async handleNewCaregiverClick() {
      if (this.careType) {
        await redirectToJobPost(this.careType, this.$router, {
          reservationId: this.reservationId || undefined,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-clickable-cards {
  .card-clickable {
    .w-64 {
      max-width: 3.5rem !important;
      width: 100%;
    }
  }
}
</style>
